<template>
  <div>
    <div class="c-confirmation-box__wrapper c-confirmation-box__wrapper--after">
      <div class="c-confirmation-box">
        <h2 class="c-confirmation-box__title" v-if="title">{{ title }}</h2>
        <div class="c-confirmation-box__description" v-html="message"></div>
        <div class="c-confirmation-box__incident" v-if="reference">Incident Number: <span class='c-confirmation-box__incident-number'>{{ reference }}</span></div>
      </div>
    </div>
    <div class="c-confirmation-box__actions" v-if="confirmationCtaUrl">
      <a v-bind:href="confirmationCtaUrl" class="c-button c-button--brand c-button--text-center">
        {{ confirmationCtaText }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      confirmationCtaUrl: {
        required: true,
        type: String
      },
      confirmationCtaText: {
        required: true,
        type: String
      },
      reference: {
        required: false,
        type: String,
      },
      message: {
        required: true,
        type: String,
      },
      title: {
        required: true,
        type: String,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/ConfirmationBox.vue